
import React from 'react';
import { FinancialData } from '@/hooks/useFinancialReporting';
import FinancialDataCard from './FinancialDataCard';
import FinancialDataCardSkeleton from './FinancialDataCardSkeleton';

interface FinancialDataListProps {
  financialData: FinancialData[];
  isLoading: boolean;
}

const FinancialDataList: React.FC<FinancialDataListProps> = ({ financialData, isLoading }) => {
  if (isLoading) {
    return (
      <div className="space-y-4">
        {[...Array(3)].map((_, i) => (
          <FinancialDataCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (financialData.length === 0) {
    return (
      <div className="text-center py-10">
        <p className="text-gray-500">No financial data available for this company.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {financialData.map((data) => (
        <FinancialDataCard key={data.id} data={data} />
      ))}
    </div>
  );
};

export default FinancialDataList;
